import * as Sentry from "@sentry/vue";
import { useOidcStore } from "vue3-oidc";

const RETRY_DELAYS_MS = [1000, 2000];
const MAX_ATTEMPTS = RETRY_DELAYS_MS.length + 1;

let pendingRedirect = null;

const wait = (delay) => new Promise((resolve) => setTimeout(resolve, delay));

const attemptRedirect = async (args) => {
  for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
    try {
      await useOidcStore().state.value.userManager.signinRedirect(args);
      return;
    } catch (error) {
      if (attempt === MAX_ATTEMPTS) {
        Sentry.captureException(error, {
          tags: { auth_step: "signinRedirect" },
          extra: {
            attempts: MAX_ATTEMPTS,
            authority: import.meta.env.VITE_APP_BD_OIDC_IP,
          },
        });
        console.error("signinRedirect failed, giving up", error);
        return;
      }
      await wait(RETRY_DELAYS_MS[attempt - 1]);
    }
  }
};

export const signinRedirectWithRetry = (args) => {
  pendingRedirect ??= attemptRedirect(args).finally(() => {
    pendingRedirect = null;
  });
  return pendingRedirect;
};
